import {motion} from 'framer-motion';
import NavIcon from './NavIcon';
import { IoArrowBackOutline } from "react-icons/io5";

function Card({
  children,
  delayTime = defaultValues.delayTime,
  hasBackNavigation = defaultValues.hasBackNavigation,
  backNavigationFunction = defaultValues.backNavigationFunction,
  backNavigationTarget = defaultValues.backNavigationTarget
}) {
  return (
    <motion.div
      className="card"
      initial={{opacity: 0}}
      animate={{opacity: 1}}
      exit={{opacity: 0}}
      transition={{duration: 1, delay: delayTime}}>
        {hasBackNavigation === true ?
          <NavIcon text='' buttonFunction={backNavigationFunction} buttonArguments={backNavigationTarget} divClass={'backButton'}>
            <IoArrowBackOutline size='25' color='#3D3D3D'/>
          </NavIcon> : null
        }
        {children}
    </motion.div>
  )
}

const emptyFunction = () => {}

const defaultValues = {
  delayTime: 0,
  hasBackNavigation: false,
  backNavigationTarget: '',
  backNavigationFunction: emptyFunction
}

export default Card